import { gql } from "@apollo/client";

export const deleteProjectQuery = gql`
  mutation deleteProjectQuery($ProjectId: ID!) {
    ProjectDelete(ProjectId: $ProjectId) {
      Id
    }
  }
`;
